<template>
  <div class="mdc-layout-grid__inner">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MaterialGrid'
}
</script>

<style lang="scss">
@import "./variables.scss";
@import "@material/layout-grid/mdc-layout-grid";
</style>
